import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
// import { Link } from '@bd/bdcore-named-routes';
import { menuToggler } from '@bd/bdcore-utilities';

import { colors, typography } from '../../styles';

const styles = css`
  padding:100px 0;

  .area-list {
      display:flex;
      flex-flow:row wrap;
      justify-content:center;
  }
  .area-list_item {
    width:100%;
    color:${colors.black};
    font:700 24px/1.2 ${typography.SansSerif};
    padding:10px;
    @media(min-width:992px){
      width:33.3333333%;
      padding:10px;
    }
  }
  .area-list_card {
    background:${colors.color3};
    padding:20px;
    text-align:center;
  }
  .Banner_Title {
    color:  white;
    font:700 18px/1 ${typography.SansSerif};
    padding:20px 30px;
    border:1px solid ${colors.color1};
    text-transform: uppercase;
    display: inline-block;
    margin-bottom: 24px;
    background: ${colors.color1};
    margin: 0 auto 40px auto;

    @media (min-width: 992px) {
      font:700 24px/1 ${typography.SansSerif};
    }
  }
`;

function AreasHome({ areas }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="row">
          <h3 className="Banner_Title">
            <span>Areas We Build In</span>
          </h3>
          <ul className="list-unstyled area-list">
            {/*
            {
              areas.map(item => (
                <li
                  className="area-list_item"
                  key={item._id}
                >
                  <Link
                    className="AreasHomePage_link"
                    name="communities"
                    params={{
                      communityMarketAreaMetro: get(item, 'name'),
                      communityMarketArea: get(item, 'name'),
                    }}
                  >
                    <div className="area-list_card">
                      <p className="AreaHome_name">{get(item, 'name')}</p>
                      <small className="AreaHome_Amt"><span className="AreaHome_Com">
                      {item.communities.length}</span> Communities | <span
                       className="AreaHome_Homes">{item.homes.length}</span> Move-In Ready</small>
                    </div>
                  </Link>
                </li>
              ))
            }
            */}
            {
              areas.map(item => (
                <li
                  className="area-list_item"
                  key={item._id}
                >
                  <div className="area-list_card">
                    <span className="AreaHome_name">{get(item, 'name')}</span>
                  </div>
                </li>
              ))
            }
          </ul>
        </div>
      </div>
    </div>
  );
}

AreasHome.propTypes = {
  areas: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData(
  {
    areas: true,
    communities: true,
    homes: true,
  },
)(menuToggler(AreasHome));



// WEBPACK FOOTER //
// ./src/pages/Communities/AreasHome.js